import { AbstractControl } from '@angular/forms';

export function ValidateEmail(control: AbstractControl) {
    const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    if(!EMAIL_REGEX.test(control.value) && control.value) {
        return {email: true};
    }
    return;
}